import { DatePickerInput, DatesRangeValue } from '@mantine/dates';

import { DateRangeFilter } from '../../data-access/types/filters';

import { useColFilter } from '@data-access';

type DateRangeFilterProps = {
  filter: DateRangeFilter;
  name: string;
};

export const DateRangeFilterComponent = ({
  filter,
  name,
}: DateRangeFilterProps) => {
  const [filterValue, setFilter] = useColFilter('orders', name);
  console.log('filterValue', filterValue, name);

  const handleChange = (value: DatesRangeValue) => {
    setFilter(value);
  };

  return (
    <DatePickerInput
      label={filter.label}
      onChange={handleChange}
      placeholder={filter.label}
      popoverProps={{ withinPortal: false }}
      type="range"
      value={(filterValue as DatesRangeValue) || [null, null]}
    />
  );
};
